export const registrationForm = {
  registrationAlias: "Alias",
  registrationName: "Name",
  registrationLastName: "Last Name",

  registrationEmail: "Email",
  registrationEmail_message: "Please enter a valid email",
  registrationEmail_required: "Email is required",
  registrationEmail_specialChar: "Special characters are not allowed",
  registrationEmail_CharStartEnd: "Email cannot start or end with special characters",
  registrationEmail_CharConsecutive: "Email cannot have consecutive special characters",

  registrationPhoneNumber: "Phone Number",
  registrationPhoneNumber_message: "Please enter a valid phone number",
  registrationPhoneNumber_tooltip: "Your phone number will be used to validate your mobile payment.",
  registrationBirthdate: "Date of Birth",
  registrationBirthdate_message: "You must be 18 years old to register",
  registrationNational_id: "ID Number",
  registrationId_message: "Please enter your ID number",
  registrationNationalIdNumbersOnly: "Only numbers from 0 to 9 are allowed",
  state: "State",
  registrationState: "State",
  registrationSelect_state: "Select State",
  registrationCity: "City",
  registrationSelect_city: "Select City",
  registrationSelectDate: "Birthdate",
  registrationPassword: "Password",
  registrationRepeatPassword: "Repeat Password",
  registrationRepeatPassword_required: "Please repeat your password",
  registrationPasswordNotMatch: "Passwords do not match",
  registrationPasswordMinLength: "Password must be at least 8 characters long",
  registrationReferralCode: "Referral Code (Optional)",
  registrationTermsAndConditions: "terms and conditions",
  registrationTermsAndConditions_: "I accept the",
  registrationAcceptTerms: "You must accept the terms and conditions",
  registrationAcceptTermsAgeCondition: "And be over 18 years of age",
  registrationAcceptTermsRegister: "Register",

  registrationAliasUnavailable: "This alias is already in use, try another one",
  registrationAliasChecking: "Checking alias availability...",
  registrationAliasAvailable: "This alias is available",

  registrationAccountValidationModal: "Register Error",
  registrationValidationModalEmail:
    "This user is already registered in the system. Please log in or use a different email address to sign up.",
  registrationValidationModalPhone: "Phone number already registered, please use another phone number.",
  registrationValidationModalId: "ID number already registered, please use another ID number.",
  registrationValidationModalError: "There was an error, please check your data.",

  // Email verification notification (deprecated - now auto-login)
  registrationEmailVerificationTitle: "Email verification",
  registrationEmailVerificationMessage:
    "A verification link has been sent to your email address. Please check your inbox and click the link to verify your account.",

  registrationBonusTitle: "Preferred Bonus",
  registrationFormBonusSlot: "Slots",
  registrationFormBonusCasino: "Live Casino",
  registrationFormBonusParley: "Parley",

  registrationSuccessTitle: "Registration Successful!",
  registrationSuccessMessage: "Welcome! You've been automatically logged in.",
  registrationError: "Registration Error",
  registrationErrorMessage: "Registration completed but we couldn't log you in automatically. Please log in manually.",
};
